const yearsExpInStockMarket = () => {
    let dif = new Date().getFullYear() - 2020;
    return dif;
}
const data = {
    socialLinks: [
        {
            name: "Gmail",
            url: "mailto:rushigandhi14@gmail.com",
            iconClass: "fa fa-envelope",
            display: false
        },
        {
            name: "GitHub",
            url: "https://github.com/Rushi0508",
            iconClass: "fa-brands fa-github",
            display: true
        },
        {
            name: "LinkedIn",
            url: "https://linkedin.com/in/rushi0508",
            iconClass: "fa-brands fa-linkedin",
            display: true
        },
        {
            name: "Twitter",
            url: "https://twitter.com/rushi_twts",
            iconClass: "fa-brands fa-twitter",
            display: true
        },
        {
            name: "Instagram",
            url: "https://instagram.com/rushi_0508",
            iconClass: "fa-brands fa-instagram",
            display: true
        },
        {
            name: "YouTube",
            url: "https://youtube.com/@rushi_0508",
            iconClass: "fa-brands fa-youtube",
            display: true
        },
        {
            name: "Medium",
            url: "https://medium.com/@rushigandhi14",
            iconClass: "fa-brands fa-medium",
            display: true
        }
    ],
    homeData: {
        l1: "Hello, I am",
        l2: "Rushi Gandhi",
        description: "I'm a Software Engineer and a Trader, currently based in Gujarat, India. Passionate in problem-solving by solution driven approach.🚀"
    },
    aboutData: {
        l1: "About Me",
        l2: "DSA | Web | App | Blockchain | AI/ML | Open Source | Finance | Books 🚀",
        content: {
            description: "I am an enthusiastic and dedicated final year student at Dharmsinh Desai University, Gujarat, with a passion for exploring the intersection of technology, finance, and spirituality. As an active learner, I thrive on adapting to new technologies and honing my skills in various domains.",
            areas: [
                {
                    name: "Academic Background",
                    description: "During my college days, I've tinkered with everything from websites to apps to Blockchain. It's been quite a ride, jumping into hackathons and club activities. Building cool, scalable stuff in the software industry? Yep, that's the plan."
                },
                {
                    name: "Finance and Trading",
                    description: `When I'm not buried in code, you'll find me nose-deep in finance. I've been dabbling in the stock market for over ${yearsExpInStockMarket()}+ years now, learning the ins and outs of trading. It's been quite the rollercoaster, but I love the thrill and the challenge it brings.`
                },
                {
                    name: "Personal Interests",
                    description: "Apart from all the tech and finance stuff, I'm just your average guy with a love for chess, cricket, and podcasts. Oh, and let's not forget about music – I'm a bit old-fashioned when it comes to that. There's something about the classics that just speaks to me."
                },
                {
                    name: "Spiritual Journey",
                    description: "Now, here's where things get a bit deep. I'm a full-time philosopher (well, in my head at least) and a part-time coder. I'm all about that inner peace and mindfulness, you know? Meditation, spiritual texts – you name it, I'm into it. Currently, I'm on a quest to explore spiritual spots across India and pen down my thoughts on Sanatan philosophy."
                },
            ]
        }
    },
    resumeData: {
        link: "https://drive.google.com/file/d/1sfXI2pUJMhT6WAiGJ5S7owujmQDZRqL_/view?usp=share_link",
        heading: "Find my updated resume by clicking the below button.",
        message: "You can contact me for hiring or any freelance projects.",
        roles: ["Freelancer", "Software Developer", "SDE Intern", "Full Stack Developer", "Backend Developer", "Frontend Developer", "App Developer", "Contract Developer"]
    }
}

export default data;